import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/societes",
    name: "societes",

    component: () => import("../views/Companies.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/exports",
    name: "exports",
    component: () => import("../views/Exports.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/notifications/:query?",
    name: "notifications",
    component: () => import("../views/Notifications.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/login-general",
    name: "login-general",
    component: () => import("../views/LoginGeneral.vue")
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("../views/ResetPassword.vue")
  },
  {
    path: "/reset-password-general",
    name: "reset-password-general",
    component: () => import("../views/ResetPasswordGeneral.vue")
  },
  {
    path: "/set-password",
    name: "set-password",
    component: () => import("../views/SetPassword.vue")
  },
  {
    path: "/set-password-general",
    name: "set-password-general",
    component: () => import("../views/SetPasswordGeneral.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch("app/SET_DESTINATION", {
      routerName: to.name,
      routerParams: to.params
    });
    if (store.getters["auth/isLoggedIn"]) {
      next();
      return;
    }
    next("/login");
  } else if (to.matched.some(record => record)) {
    next();
  } else {
    next("/login");
  }
});

export default router;
